<div class="product-card">
    <a [routerLink]="['/products', product.slug]" class="product-card__link">
      <div>
        <div class="product-card--image-card">
          @if (product.imageUrl) {
            <img 
              [src]="product.imageUrl" 
              [alt]="product.offerProductName" 
              class="product-card__image" 
              loading="lazy" />
          } @else {
            <img 
              src="/img/no-image.svg" 
              [alt]="product.offerProductName" 
              class="product-card__image" 
              loading="lazy" />
          }
          @if (product.discountedPrice > 0) {
            <p class="product-card__sale">
              {{ calculateDiscountPercentage(product.regularPrice, product.discountedPrice) }}%
            </p>
          }
        </div>
        <h3 [title]="product.offerProductName" class="product-card__name">
          {{ truncateText(product.offerProductName, 40) }}
        </h3>
      </div>
  
      <div class="product-card__container">
        @if (product.regularPrice > 0) {
          <p class="small">
            {{ toDenars(product.regularPrice) }}
          </p>
        }
        <div class="d-flex">
          <p class="product-card__price">
            {{ product.discountedPrice > 0 ? toDenars(product.discountedPrice) : toDenars(product.regularPrice) }}
          </p>
        </div>
        <div class="product-card__stores">
          <p>во {{ product.nbVendors }} продавници</p>
        </div>
      </div>
    </a>
    <button class="product-card__icon product-card__icon--bell" aria-label="add to watch list">
      <app-bell></app-bell>
    </button>
    <button class="product-card__icon product-card__icon--heart" aria-label="add to favorites">
      <app-heart></app-heart>
    </button>
  </div>